export enum AssetType {
    invoice = 1,
    insurancePolicy = 2,
    approvedLimit = 3,
    payment = 4,
    remittanceAdvice = 5,
    invoiceMonetization = 6,
    creditNote = 7,
    purchaseOrder = 8,
    invoiceSoc = 9,
    multiAsset = 10,
    unappliedCash = 11,
    customerReferenceData = 12
}

export let AssetTypesDisplay: { [index: number]: string } = {};
AssetTypesDisplay[AssetType.invoice] = "Invoice";
AssetTypesDisplay[AssetType.insurancePolicy] = "Insurance Policy";
AssetTypesDisplay[AssetType.approvedLimit] = "Approved Limit";
AssetTypesDisplay[AssetType.payment] = "Payment";
AssetTypesDisplay[AssetType.remittanceAdvice] = "Remittance Advice";
AssetTypesDisplay[AssetType.invoiceMonetization] = "Invoice Monetization";
AssetTypesDisplay[AssetType.creditNote] = "Credit Note";
AssetTypesDisplay[AssetType.purchaseOrder] = "Purchase Order";
AssetTypesDisplay[AssetType.invoiceSoc] = "InvoiceSoc";
AssetTypesDisplay[AssetType.multiAsset] = "Multiple Asset";
AssetTypesDisplay[AssetType.unappliedCash] = "Unapplied Cash";
AssetTypesDisplay[AssetType.customerReferenceData] = "Customer Reference Data";

export function IsOfType(str: String, at: AssetType) : boolean{
    if(AssetTypesDisplay[at].toLowerCase()==str.toLowerCase())
        return true;
    return false;
}